import CommonEdit from "@/components/common/Edit"
import ServiceForm from "../forms/ServiceForm"
import { FC, useEffect, useState } from "react"
import { serviceForm } from "@/utils/objects"
import { singleProp } from "@/interface/dataInterface"
import axiosInstance from "@/utils/axiosInstance"

const ServiceEdit: FC<singleProp> = ({prop}) => {
    const [formProp, setFormProp] = useState(serviceForm)

    useEffect(() => {
        const unsub = async () => {
            if (!prop) return;
            const response = await axiosInstance.get(`/auto-service/${prop}`)
            setFormProp(response.data)
        }

        unsub()
    }, [prop])

    return (
        <CommonEdit title="Edit" id={prop} resource="auto-service" data={formProp}>
            <ServiceForm mode="edit" formProp={formProp} setFormProp={setFormProp} />
        </CommonEdit>
    )
}

export default ServiceEdit